/* eslint-disable react-hooks/exhaustive-deps */
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Grid, Box as MuiBox, Button as MuiButton, Typography, Link, CircularProgress, Box } from '@mui/material';
import * as moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TextInput } from '@theguarantors/ui-kit-v3';
import { GooglePlaceInput } from 'src/components/GooglePlaceInput/GooglePlaceInput';
import { CoviePage } from 'src/components/Covie/Covie';
import { DatePicker } from 'src/components/FormComponents/Components/DatePicker';
import { COVIE_APPLICATION_UPLOAD } from 'src/configs/APISchemas/CovieApplicationUploadGraphQL';
import { VALIDATE_APPLICATION_POLICY } from 'src/configs/APISchemas/ValidateUserPolicyGraphQL';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';
import { saveDataToStore } from 'src/redux/actions';
import { UpdateApplication, UpdateApplicationRoute, UpdateComplianceErrors, UpdateCovieData } from 'src/redux/actions/Application';
import { STATES } from '../../constants/states';
import { Store } from 'src/types';
import { ComplianceApplication } from './ComplianceForm.types';
import { StyledDropdown } from './ComplianceForm.styles';
import ComplianceHelper from 'src/components/Compliance/ComplianceHelper';
import ApplicationSchema from 'src/configs/APISchemas/Application.schema';
import CompanyDropdown from 'src/components/Company/CompanyDropdown';
import { ScrollToTop } from 'src/components/ScrollToTopComponent/ScrollToTop';
import { LogoLoader } from 'src/components/LogoLoader/LogoLoader';

const ComplianceForm = () => {
  const application = useSelector((store: Store) => store.application);
  const [loading, setLoading] = useState<boolean>(false);
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [activeCovie, setActiveCovie] = useState<boolean>(false);
  const [activeCovieLink, setActiveCovieLink] = useState<string | null>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const bottom = useRef<null | HTMLDivElement>(null);
  const [addressDetails, setAddressDetails] = useState<any>({});
  const quoteData = useSelector((state: any) => state.general?.quote);
  const [disabledContinueButton, setDisabledContinueButton] = useState<boolean>(true)
  const [startDateHasBeenDefinedOnce, setStartDateHasBeenDefinedOnce] = useState<boolean>(false)
  const [endDateHasBeenDefinedOnce, setEndDateHasBeenDefinedOnce] = useState<boolean>(false)
  const [currentFormTarget, setCurrentFormTarget] = useState<any>()

  const formHook = useForm<ComplianceApplication>({
    defaultValues: {},
  });
  const {
    control,
    handleSubmit,
    setValue,
    setFocus,
    getValues,
  } = formHook;

  useEffect(() => {
    if (quoteData && quoteData.addressName) {
      setValue('addressName', quoteData.addressName);
      setValue('address.addressNumber', quoteData.address.addressNumber);
      setValue('address.street', quoteData.address.street);
      setValue('address.shortNameStreet', quoteData.address.shortNameStreet);
      setValue('address.municipality', quoteData.address.municipality);
      setValue('address.postalCode', quoteData.address.postalCode);
      setValue('address.state', quoteData.address.state);
    }
  }, []);

  const onFormValueChange = (event: React.FormEvent<HTMLFormElement>) => {
    setCurrentFormTarget(event.currentTarget)
  }

  const companyAddressSelection = (selectedAddress: ApplicationSchema["buildingAddress"]["value"]) => {

    if (!selectedAddress) { return }

    setValue('buildingId', selectedAddress.id || '')
    setValue('addressName', selectedAddress.name);
    setValue('building_name', selectedAddress.name || '');
    setValue('address.postalCode', selectedAddress.postalCode);
    setValue('address.state', selectedAddress.state);
    setValue('address.municipality', selectedAddress.municipality);

    let tempAddress: string[] = [];
    if (!selectedAddress.addressNumber || selectedAddress.addressNumber == '') {
      const regex = /(^[0-9]+)(\s)(.*)/i;
      tempAddress = selectedAddress.street.split(regex);
    }
    setValue('address.addressNumber', tempAddress[1] || '');
    setValue('address.street', tempAddress[3] || selectedAddress.street);
    setValue('address.shortNameStreet', tempAddress[3] || selectedAddress.street);
    setFocus('buildingUnit');
  };

  const enableContinueButtonIfFieldsFilled = () => {
    const areFieldsFilled = currentFormTarget?.given_name?.value !== '' &&
      currentFormTarget?.family_name?.value !== '' && currentFormTarget?.email?.value !== '' && currentFormTarget?.addressName?.value !== '' && currentFormTarget?.address?.addressNumber?.value !== '' &&
      currentFormTarget?.address?.street?.value !== '' && currentFormTarget?.address?.shortNameStreet?.value !== '' && currentFormTarget?.address?.municipality?.value !== '' && currentFormTarget?.address?.postalCode?.value !== '' && currentFormTarget?.address?.state?.value !== '' &&
      startDateHasBeenDefinedOnce && endDateHasBeenDefinedOnce

    setDisabledContinueButton(!areFieldsFilled)
  }

  useEffect(() => {
    enableContinueButtonIfFieldsFilled();
  }, [currentFormTarget, startDateHasBeenDefinedOnce, endDateHasBeenDefinedOnce])


  const onSubmit = async (values: ComplianceApplication) => {
    if (
      values.start_date &&
      values.end_date &&
      values?.start_date > values?.end_date
    ) {
      toast('Start date should be greater than the end date', {
        type: 'error',
      });
    } else {
      try {
        setLoading(true);
        dispatch(
          saveDataToStore({
            quote: values,
          }),
        );
        const mutation = VALIDATE_APPLICATION_POLICY(
          values.address,
          values.buildingUnit,
          values.email,
          values.given_name,
          values.family_name,
          values.start_date || '',
          values.end_date || '',
        );
        const response = await GraphQLRequest(mutation);
        if (response.validateApplicationPolicy?.application?.id) {
          switch (response.validateApplicationPolicy?.application.status) {
            case 'compliant': {
              history.push('/compliance/already-verified');
              break;
            }
            case 'unstarted': {
              setActiveCovie(true);
              if (bottom !== null) {
                bottom.current?.scrollIntoView();
              }

              break;
            }
            case 'expired': {
              history.push('/compliance/coverage-not-compliant');
              break;
            }
            case 'complianceStarted':
            case 'needsReview': {
              history.push('/compliance/upload-success');
              break;
            }
            default: {
              setActiveCovieLink(response.validateApplicationPolicy?.linkId || null);
              setActiveCovie(true);
              if (bottom !== null) {
                bottom.current?.scrollIntoView();
              }
              break;
            }
          }
          return;
        } else {
          if (response.validateApplicationPolicy?.validation?.errors) {
            dispatch(
              UpdateComplianceErrors(
                response.validateApplicationPolicy.validation.errors,
              ),
            );
            history.push('/compliance/coverage-not-compliant');
          } else if (response.validateApplicationPolicy.errors) {
            switch (response.validateApplicationPolicy.errors[0].type) {
              case 'APPLICATION_NOT_FOUND':
              case 'ADDRESS':
                setActiveCovie(true);
                if (bottom !== null) {
                  bottom.current?.scrollIntoView();
                }
                break;
              case 'APPLICATION_ALREADY_COMPLIANT':
                history.push('/compliance/already-verified');
                break;
              default:
                dispatch(
                  UpdateComplianceErrors(
                    response.validateApplicationPolicy.errors,
                  ),
                );
                history.push('/compliance/coverage-not-compliant');
                break;
            }
            return;
          }
          toast('Unknown response', {
            type: 'error',
          });
          return;
        }
      } catch (error: any) {
        if (error?.response?.data?.errors) {
          return toast(error.response.data.errors[0].message, {
            type: 'error',
          });
        }
        toast('We are having some trouble, Please contact support for help.', {
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCantFindAddressInCompanyList = () => {
    dispatch(
      UpdateApplication({
        ...application.data,
        buildingName: undefined,
        buildingId: undefined,
        addressName: undefined,
        buildingAddress: undefined,
        address: undefined,
        COMPANY_VENDOR: undefined,
      })
    )
  }

  const handleSelect = (address: any, addressDetails: any) => {
    const selectedAddress = addressDetails[0];
    if (selectedAddress) {
      const street =
        (
          selectedAddress.address_components.find((add: any) =>
            add.types.includes('route'),
          ) || {}
        ).long_name || '';
      const shortNameStreet =
        (
          selectedAddress.address_components.find((add: any) =>
            add.types.includes('route'),
          ) || {}
        ).short_name || '';
      const address_number =
        (
          selectedAddress.address_components.find((add: any) =>
            add.types.includes('street_number'),
          ) || {}
        ).long_name || '';
      const municipality =
        (
          selectedAddress.address_components.find(
            (add: any) =>
              add.types.includes('locality') ||
              add.types.includes('sublocality'),
          ) || {}
        ).long_name || '';
      const postal_code =
        (
          selectedAddress.address_components.find((add: any) =>
            add.types.includes('postal_code'),
          ) || {}
        ).long_name || '';
      const city =
        (
          selectedAddress.address_components.find((add: any) =>
            add.types.includes('locality'),
          ) || {}
        ).short_name || '';
      const state =
        (
          selectedAddress.address_components.find((add: any) =>
            add.types.includes('administrative_area_level_1'),
          ) || {}
        ).short_name || '';
      const cityToUse = city || municipality;
      const formattedAddress = `${address_number} ${street}, ${cityToUse}, ${state}, USA`;
      setAddressDetails({
        address_number: address_number,
        street: street.trim(),
        municipality: cityToUse,
        state: state,
        postal_code: postal_code,
        complete_address: address,
        name: address,
      });
      setValue('addressName', formattedAddress);
      setValue('address.postalCode', postal_code);
      setValue('address.state', state);
      setValue('address.municipality', cityToUse);
      setValue('address.street', street);
      setValue('address.shortNameStreet', shortNameStreet);
      setValue('address.addressNumber', address_number);
      if (address_number) {
        setFocus('buildingUnit');
      } else {
        setFocus('address.addressNumber');
      }
    } else {
      setValue('addressName', address);
    }
  };

  const onDocumentUpload = async (link: string) => {
    const firstName = quoteData.given_name.trim();
    const lastName = quoteData.family_name.trim();
    const name = `${firstName} ${lastName}`;
    const mutation = COVIE_APPLICATION_UPLOAD(
      name,
      firstName,
      lastName,
      quoteData.email,
      {
        street: quoteData.address.street,
        addressNumber: quoteData.address.addressNumber,
        postalCode: quoteData.address.postalCode,
        municipality: quoteData.address.municipality,
        region: quoteData.address.state,
      },
      quoteData.buildingUnit,
      link,
    );
    const response = await GraphQLRequest(mutation);
    if (response.applicationUpload?.id) {
      history.push('/compliance/upload-success');
    } else {
      toast('Unknown response', {
        type: 'error',
      });
      return;
    }
  };

  return (
    <div>
      {pageLoading && application.data.COMPANY_VENDOR && <MuiBox
        position="absolute"
        zIndex="2000"
        paddingBottom={{ xs: 80, lg: 40 }}
        height="100%"
        width="100%"
        sx={{ bgcolor: "white" }}
      >
        <ScrollToTop />
        <MuiBox
          position="absolute"
          height="80vh"
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <LogoLoader />
        </MuiBox>
      </MuiBox>}
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        marginTop={10}
      >
        <MuiBox
          paddingX={{ xs: 5, xl: 30 }}
          maxWidth={1200}
        >
          <Grid container rowSpacing={3} direction="column">
            <Grid item>
              <MuiButton
                onClick={() => { dispatch(UpdateApplicationRoute('/compliance/welcome')); history.push('compliance/welcome') }}
                variant="text"
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </MuiButton>
            </Grid>
            <Grid item>
              <Typography variant="h3">
                Validate your renters insurance
              </Typography>
            </Grid>
            <ComplianceHelper />
            <form onSubmit={handleSubmit(onSubmit)} onChange={onFormValueChange} className="mt-4">
              <Grid container rowSpacing={3} direction="column">
                <Grid item>
                  <Grid
                    container
                    flexDirection={{ xs: 'column', md: 'row' }}
                    spacing={3}
                  >
                    <Grid item xs={12} lg={4}>
                      <Typography variant="h6">
                        Tell us about yourself.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                      <Grid container spacing={2} columnSpacing={4}>
                        <Grid item xs={12} md={6}>
                          <Controller
                            control={control}
                            name={'given_name'}
                            rules={{
                              required: true,
                              maxLength: 50,
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                            }) =>
                              <TextInput
                                required maxLength={50} label="First Name"
                                pattern="[\w -]*" name={name}
                                onChange={onChange} onBlur={onBlur}
                                value={value} setInputRef={ref}
                              ></TextInput>
                            }
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controller
                            control={control}
                            name={'family_name'}
                            rules={{
                              required: true,
                              maxLength: 50,
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                            }) => <TextInput
                              required
                              maxLength={50}
                              label="Last Name"
                              name={name}
                              pattern="[\w -]*"
                              onChange={onChange}
                              onBlur={onBlur}
                              value={value}
                              setInputRef={ref}
                            ></TextInput>
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Controller
                            control={control}
                            name={'email'}
                            rules={{
                              required: true,
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                            }) => <TextInput
                              label="Email"
                              type={'email'}
                              pattern="^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                              required
                              name={name}
                              onChange={onChange}
                              onBlur={onBlur}
                              value={value}
                              setInputRef={ref}
                            ></TextInput>
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid
                    container
                    flexDirection={{ xs: 'column', md: 'row' }}
                    spacing={3}
                  >
                    <Grid item xs={12} lg={4}>
                      <Typography variant="h6">
                        Where is the address that you are renting?
                      </Typography>
                      <Typography variant="body1">
                        This is the address that will be used for your renters
                        insurance policy.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                      {application.data.COMPANY_VENDOR ? <Grid item xs={12} display="flex" flexDirection="column" flexWrap='nowrap' marginBottom={2}>
                        <Controller
                          control={control}
                          name={'buildingId'}
                          rules={{
                            required: true,
                          }}
                          render={({
                            field: { onBlur, value },
                          }) => <CompanyDropdown
                              value={value}
                              placeholder="Search Property"
                              onChange={companyAddressSelection}
                              setPageLoading={setPageLoading}
                              onBlur={onBlur}
                            />
                          }
                        />
                        <Typography variant="body2" paddingLeft="18px">
                          Can’t find your address in the list? <Link onClick={handleCantFindAddressInCompanyList} href="/compliance" style={{ color: 'inherit' }}> Click here </Link>
                        </Typography>
                      </Grid>
                        :
                        <Box marginBottom={2}>
                          <GooglePlaceInput
                            onPlaceSelect={handleSelect}
                            onPlaceError={() => { }}
                            placeHolder="Street Address"
                            label="Street Address"
                            name="addressName"
                            inputText={getValues('addressName')}
                          ></GooglePlaceInput>
                        </Box>
                      }
                      <Grid container spacing={2} columnSpacing={4}>
                        {!application.data.COMPANY_VENDOR && <>
                          {addressDetails.name && (
                            <>
                              {!addressDetails.address_number && (
                                <Grid item xs={12}>
                                  <Controller
                                    control={control}
                                    name={'address.addressNumber'}
                                    rules={{
                                      required: true,
                                      maxLength: 6,
                                    }}
                                    render={({
                                      field: {
                                        onChange,
                                        onBlur,
                                        value,
                                        name,
                                        ref,
                                      },
                                    }) => <TextInput
                                      controlled={false}
                                      type={'number'}
                                      label="Address Number"
                                      minLength={1}
                                      required
                                      name={name}
                                      onChange={onChange}
                                      onBlur={onBlur}
                                      value={value}
                                      setInputRef={ref}
                                    ></TextInput>
                                    }
                                  />
                                </Grid>
                              )}
                            </>
                          )}
                          {addressDetails.name && (
                            <>
                              {!addressDetails.street && (
                                <Grid
                                  item
                                  xs={12}
                                  md={!addressDetails.municipality ? 6 : 12}
                                >
                                  <Controller
                                    control={control}
                                    name={'address.street'}
                                    rules={{
                                      required: true,
                                      maxLength: 6,
                                    }}
                                    render={({
                                      field: {
                                        onChange,
                                        onBlur,
                                        value,
                                        name,
                                        ref,
                                      },
                                    }) => <TextInput
                                      controlled={false}
                                      label="Street"
                                      minLength={1}
                                      required
                                      name={name}
                                      onChange={onChange}
                                      onBlur={onBlur}
                                      value={value}
                                      setInputRef={ref}
                                    ></TextInput>
                                    }
                                  />
                                </Grid>
                              )}
                              {!addressDetails.municipality && (
                                <Grid
                                  item
                                  xs={12}
                                  md={!addressDetails.street ? 6 : 12}
                                >
                                  <Controller
                                    control={control}
                                    name={'address.municipality'}
                                    rules={{
                                      required: true,
                                    }}
                                    render={({
                                      field: {
                                        onChange,
                                        onBlur,
                                        value,
                                        name,
                                        ref,
                                      },
                                    }) => <TextInput
                                      controlled={false}
                                      label="Municipality"
                                      minLength={1}
                                      required
                                      name={name}
                                      onChange={onChange}
                                      onBlur={onBlur}
                                      value={value}
                                      setInputRef={ref}
                                    ></TextInput>
                                    }
                                  />
                                </Grid>
                              )}
                            </>
                          )}
                          {addressDetails.name && (
                            <>
                              <Grid item xs={12} md={6}>
                                <Controller
                                  control={control}
                                  name={'address.state'}
                                  rules={{
                                    required: true,
                                  }}
                                  render={({
                                    field: { onChange, onBlur, value, name },
                                  }) => <StyledDropdown
                                      id={'statedropdown'}
                                      className="dropdown"
                                      value={value}
                                      placeholder="State"
                                      isSearchable
                                      onChange={onChange}
                                      options={STATES}
                                      name={name}
                                      onBlur={onBlur}
                                    />
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controller
                                  control={control}
                                  name={'address.postalCode'}
                                  rules={{
                                    required: true,
                                    maxLength: 6,
                                  }}
                                  render={({
                                    field: { onChange, onBlur, value, name, ref },
                                  }) => <TextInput
                                    controlled={false}
                                    label="Postal Code"
                                    type={'number'}
                                    minLength={1}
                                    maxLength={6}
                                    required
                                    name={name}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    setInputRef={ref}
                                  ></TextInput>
                                  }
                                />
                              </Grid>
                            </>
                          )}
                        </>}
                        <Grid item xs={12}>
                          <Controller
                            control={control}
                            name={'buildingUnit'}
                            rules={{
                              required: false,
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                            }) => (
                              <TextInput
                                controlled={false}
                                label="Unit Number"
                                maxLength={50}
                                name={name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                setInputRef={ref}
                              ></TextInput>
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid
                    container
                    flexDirection={{ xs: 'column', md: 'row' }}
                    spacing={3}
                  >
                    <Grid item xs={12} lg={4}>
                      <Typography variant="h6">
                        What is your lease start date?
                      </Typography>
                      <Typography variant="body1">
                        What date does your contract start?
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                      <Controller
                        control={control}
                        name={'start_date'}
                        rules={{
                          required: true,
                        }}
                        render={({ field: { onChange, value, name } }) => (
                          <DatePicker
                            onChange={onChange}
                            onSelect={() => { setStartDateHasBeenDefinedOnce(true) }}
                            value={value}
                            name={name}
                            label={'Start Date'}
                            minDate={new Date('01/01/1950')}
                            startYear={parseInt(
                              moment
                                .default()
                                .subtract(72, 'year')
                                .format('YYYY'),
                            )}
                            endYear={parseInt(
                              moment.default().add(1, 'year').format('YYYY'),
                            )}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid
                    container
                    flexDirection={{ xs: 'column', md: 'row' }}
                    spacing={3}
                  >
                    <Grid item xs={12} lg={4}>
                      <Typography variant="h6">
                        What is your lease end date?
                      </Typography>
                      <Typography variant="body1">
                        What date does your contract end?
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                      <Controller
                        control={control}
                        name={'end_date'}
                        rules={{
                          required: true,
                        }}
                        render={({ field: { onChange, value, name } }) => (
                          <DatePicker
                            onChange={onChange}
                            onSelect={() => { setEndDateHasBeenDefinedOnce(true) }}
                            value={value}
                            name={name}
                            label={'End Date'}
                            minDate={new Date()}
                            startYear={parseInt(
                              moment.default().format('YYYY'),
                            )}
                            endYear={parseInt(
                              moment.default().add(10, 'year').format('YYYY'),
                            )}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {!activeCovie && (
                  <Grid item>
                    <Grid
                      container
                      flexDirection={{ xs: 'column', md: 'row' }}
                      justifyContent="flex-end"
                      spacing={3}
                    >
                      <Grid item xs={12} display='flex' justifyContent='flex-end'>
                        <MuiButton
                          variant="contained"
                          type="submit"
                          // loading={loading}
                          disabled={disabledContinueButton}
                          fullWidth={true}
                          startIcon={
                            loading ? <CircularProgress color="inherit" size="17px" /> : ''
                          }
                        >
                          {' '}
                          Continue <ArrowForwardIosIcon sx={{ height: "20px" }} />
                        </MuiButton>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <MuiBox ref={bottom}>
                  {activeCovie && (
                    <CoviePage
                      onError={() => {
                        history.push('/compliance/nopolicylocated');
                      }}
                      activeCovieLink={activeCovieLink}
                      onDocumentUpload={onDocumentUpload}
                      metaData={
                        quoteData
                          ? {
                            lastName: quoteData.family_name, firstName: quoteData.given_name,
                            email: quoteData.email,
                            address: `${quoteData.address.addressNumber || ''} ${quoteData.address.street || ''}, ${quoteData.address.municipality || ''},${quoteData.address.state || ''} ${quoteData.address.postalCode || ''}`,
                            unit: quoteData.buildingUnit,
                            leaseStartDate: moment.default(quoteData.start_date).format('MM/DD/YYYY'),
                            policyNumber: 'NULL', policyProvider: 'NULL', policyEffectiveDate: 'MM/DD/YYYY', policyExpirationDate: 'MM/DD/YYYY', personalLiabilityCoverage: 'NULL',
                            personalPropertyCoverage: 'NULL', medicalPayments: 'NULL', complianceStatus: 'needs-review', correctName: 'NULL', correctAddress: 'NULL', correctDates:'NULL'
                          }
                          : undefined
                      }
                      onSuccess={(data) => {
                        dispatch(
                          UpdateCovieData({
                            carrier: data.carrier,
                            inception_date: data.inception_date,
                          }),
                        );
                        history.push(`/compliance/${data.id}`);
                      }}
                    />
                  )}
                </MuiBox>
              </Grid>
            </form>
          </Grid>
        </MuiBox>
      </Grid>
    </div>
  );
};

export default ComplianceForm;
